import { useMemo } from "react";
import useConfig from "./useConfig";
import type { Environment } from "../services/ConfigService";

interface UseEnvironmentReturn {
  environment: Environment | undefined;
  isProd: boolean;
  isPreprod: boolean;
  isLoading: boolean;
}

/**
 * Hook to access the current environment configuration.
 * Returns environment value and helper flags for environment-specific logic.
 */
const useEnvironment = (): UseEnvironmentReturn => {
  const { data, isSuccess } = useConfig();
  const normalizedEnvironment = data?.environment?.toLowerCase();

  return useMemo(
    () => ({
      environment: data?.environment,
      isProd: normalizedEnvironment === "prod",
      isPreprod: normalizedEnvironment === "preprod",
      isLoading: !isSuccess,
    }),
    [data?.environment, isSuccess, normalizedEnvironment],
  );
};

export default useEnvironment;
